export type DeletionAvailability = { allowed: boolean; code: string }

/** Checks the same backend rules as DELETE before asking the user to confirm. */
export async function getDeletionAvailability(url: string): Promise<DeletionAvailability> {
  const queryIndex = url.indexOf('?')
  const path = queryIndex < 0 ? url : url.slice(0, queryIndex)
  const query = queryIndex < 0 ? '' : url.slice(queryIndex)
  const response = await apiFetch(`${path}/deletion-status${query}`, { credentials: 'include' })
  const payload = await response.json().catch(() => null) as DeletionAvailability | { code?: string } | null
  if (!response.ok) throw new Error(payload?.code ?? 'deletion.unavailable')
  return payload as DeletionAvailability
}
import { apiFetch } from '../http/apiFetch'
